var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonApiRelated = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M30.237 31.286c0-.714.578-1.292 1.292-1.292h1.778a7.015 7.015 0 016.993 7.012A7.015 7.015 0 0133.307 44h-1.778a1.291 1.291 0 01-1.292-1.292V31.286z", fill: fills.dark }),
        React.createElement("path", { d: "M22.23 31.286c0-.714-.579-1.292-1.293-1.292h-1.778a7.015 7.015 0 00-6.993 7.012A7.015 7.015 0 0019.159 44h1.778c.714 0 1.292-.578 1.292-1.292V31.286zM33.99 11.486H31.74c-1.377-5.336-6.82-8.545-12.155-7.168a9.98 9.98 0 002.502 19.64H33.99a6.236 6.236 0 100-12.471z", fill: fills.light }),
        React.createElement("path", { d: "M15.11 38.077H9.07c-2.797 0-5.07-2.2-5.07-4.905V17.777c0-2.704 2.275-4.904 5.07-4.904h6.04v2.122H9.07c-1.625 0-2.948 1.247-2.948 2.782v15.395c0 1.535 1.323 2.783 2.948 2.783h6.04v2.122z", fill: fills.light }),
        React.createElement("path", { d: "M31.088 34.017h-3.907a1.021 1.021 0 010-2.042h3.907v2.042zM39.31 38.044h3.907a1.021 1.021 0 000-2.042H39.31v2.042zM31.088 41.984h-3.907a1.021 1.021 0 010-2.042h3.907v2.042z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
